import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

import { BaseCard } from "../base-card/base-card.styles"

import ButtonLink from "../btn-collections/btn-collections.component"

export const CardContainer = styled(BaseCard)`
  display: flex;
  flex: auto;
  flex-direction: column;
  /*grid-column: ${(props) => props.cardType === "small-course-card" ? "span 3" : "span 4"};*/
  grid-column: span 4;
  position: relative;
  border-radius: 5px;
  @media screen and (max-width: 1280px) {
    grid-column: span 6;
  }
  @media screen and (max-width: 760px) {
    grid-column: span 12;
  }
`

export const ImgContainer = styled(GatsbyImage)`
  cursor: pointer;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  border-radius: 5px 5px 0 0;
  
  img {
    border-radius: 5px 5px 0 0;
  }
  

  /* targets iPhones */
  @media only screen and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 2) {
    img {
      object-fit: cover !important;
    }
  }

  /* Chrome on iPhone */
  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    img {
      object-fit: cover !important;
    }
  }

  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    img {
      object-fit: cover !important;
    }
  }

  @media only screen and (max-width: 812px) {
    img {
      object-fit: cover !important;
    }
  }
`

ImgContainer.displayName = "ImgContainer"

export const ContentContainer = styled.div`
  padding: ${(props) => props.cardType === "small-course-card" ? "18px 23px 25px 23px" : "20px 25px 25px 25px"}; /*offset title inner spacing*/
  display: flex;
  flex-direction: column;
  height: 100%;
`
ContentContainer.displayName = "ContentContainer"

export const CardTitle = styled.a`
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  font-size: ${(props) => props.cardType === "small-course-card" ? "18px" : "22px"}; 
  line-height: ${(props) => props.cardType === "small-course-card" ? "26px" : "32px"};
  color: ${({ theme: { colors } }) => colors.black};
  cursor: pointer;
  text-decoration: none;
  flex-grow: 1;
  @media screen and (max-width: 760px) {
    font-size: 18px;
    line-height: 26px;
  }
`
CardTitle.displayName = "CardTitle"

export const Excerpt = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin: ${(props) => props.cardType === "small-course-card" ? "10px 0 15px" : "15px 0px"}; /*offset inner spacing*/
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.light};
  color: ${({ theme: { colors } }) => colors.darkGrey};
  flex: 1 1 auto;
  @media screen and (max-width: 760px) {
    font-size: 15px;
    line-height: 23px;
  }
`
Excerpt.displayName = "Excerpt"

export const AuthorsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
`

AuthorsContainer.displayName = "AuthorsContainer"

export const AuthorCard = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  line-height: 18px;

  & a {
    text-decoration: none;
    display: inline-block;
  }
`

AuthorCard.displayName = "AuthorCard"

export const AuthorName = styled.span`
  font-size: 14px;
  color: ${({ theme: { colors } }) => colors.grey};
  margin-left: ${({ index }) => (index === 0 ? "0" : "2px")};
  margin-top: 5px;
  @media screen and (max-width: 768px) {
    font-size: 13px;
  }

  ${({ isInstructor }) =>
    isInstructor &&
    `
    padding: 1px;
    border-bottom: 1px solid #000;
    &:hover {
     border-width: 3px
  `};
`
AuthorName.displayName = "AuthorName"

export const AuthorImage = styled.div`
  height: 35px;
  min-width: 36px;
  border-radius: 50%;
  border: ${({ index }) => (index === 0 ? '2px solid rgb(76, 15, 251)' : '2px solid rgb(245, 23, 103)')};
  margin-left: ${({ index }) => (index === 1 ? '-15px' : '0')};
  overflow: hidden;
  background: ${({ img }) => `url(${img}) center center no-repeat`};
  background-size: cover;
  margin-right: 9px;
  @media screen and (max-width: 768px) {
    height: 30px;
    min-width: 31px;
  }
`

AuthorImage.displayName = "AuthorImage"

export const ButtonsContainer = styled.div`
  margin-top: 20px;
  display: flex;
`

ButtonsContainer.displayName = "ButtonsContainer"

export const BtnLink = styled(ButtonLink)`
  width: 100%;

  &:nth-child(2) {
    margin-left: 10px;
  }
  /*when card at 2 columns button padding need to be 0 to avoid overflow*/
  @media screen and (max-width: 1280px) {
    padding: 0px;
  }
`

BtnLink.displayName = "BtnLink"

export const TimeDetails = styled.span`
  font-size: 14px;
  line-height: 13px;
  display: flex;
  align-items: center;
  margin-top: ${(props) => props.cardType === "small-course-card" ? "13px" : "15px"}; /*offset title inner spacing*/
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  color: ${({ theme: { colors } }) => colors.grey};
  & span {
    font-size: 18px;
    color: ${({ theme: { colors } }) => colors.accentBlue};
    margin: 0 8px 3px;
  }

  & svg {
    margin-right: 10px;
    font-size: 16px;
    height: 20px;
    width: 20px;
    stroke: ${({ theme: { colors } }) => colors.accentBlue};
  }
  @media screen and (max-width: 768px) {
    font-size: 13px;
    margin-top: 10px;
  }
`

TimeDetails.displayName = "TimeDetails"
